<mat-form-field
  class="form-field"
  hideRequiredMarker
  appearance="fill">
  <mat-label>{{ row.label | translate | requiredAsterisk: row.control }}</mat-label>
  <input
    matInput
    [type]="row.type"
    [placeholder]="row.placeholder | translate"
    [formControl]="row.control"
    [minlength]="row.minLength"
    [maxlength]="row.maxLength"
    [min]="row.min"
    [max]="row.max"
    [matAutocomplete]="auto" />
  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
    @for (option of filteredOptions | async; track $index) {
      <mat-option [value]="option">
        {{ row.displayFn ? (row.displayFn(option) | translate) : option }}
      </mat-option>
    }
  </mat-autocomplete>

  @if (row.control.invalid) {
    <mat-error>
      {{ 'validationErrors.' + row.validationError | translate }}
    </mat-error>
  }
</mat-form-field>
